import React, { useRef, useState } from "react";
import { useEffect } from "react";
import IonRangeSlider from "react-ion-slider";
import moment from "moment";
import { longDateString } from "../utils";
function RangeSelector(props) {
    const rangeSlider = useRef(0);
    const [start, setStart] = useState(props.start || 0);
    const [end, setEnd] = useState(props.end || 1000);
    const [from, setFrom] = useState(props.from || start + 1);
    const [to, setTo] = useState(props.to || end - 10);
    const [steps, setSteps] = useState(props.steps || 2);
    const [dragWidth, setDragWidth] = useState(props.dragWidth || 100);
    useEffect(() => {
        const duration = end - start;
        setDragWidth(duration / steps);
        setFrom(start);
        setTo(start + dragWidth);
        console.log(
            duration,
            steps,
            dragWidth,
            start,
            end,
            rangeSlider.current.min_interval,
            rangeSlider.current.max_interval
        );
    }, [start, end, steps]);
    // console.log("tiems", start, end);
    return (
        <>
            {/* Range slider to adjust duration values */}
            <div className="container-fluid">
                <div className="row">
                    <div className="col">
                        <IonRangeSlider
                            forceEdges={true}
                            ref={rangeSlider}
                            skin={"flat"}
                            type={"double"}
                            drag_interval={true}
                            min={start}
                            max={end}
                            from={from}
                            to={to}
                            min_interval={dragWidth}
                            max_interval={dragWidth}
                            prettify={longDateString}
                            onFinish={(e) => {
                                console.log("range is changed to", e);
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default RangeSelector;
